import { render } from "./findingTaskEdit.vue?vue&type=template&id=989459fe&scoped=true&ts=true"
import script from "./findingTaskEdit.vue?vue&type=script&lang=ts"
export * from "./findingTaskEdit.vue?vue&type=script&lang=ts"

import "./findingTaskEdit.vue?vue&type=style&index=0&id=989459fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-989459fe"]])

export default __exports__